import React from 'react'
import IncidentalDepositPresenter from '../../IncidentalDepositPresenter/IncidentalDepositPresenter'
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"

export default class RoomTypePresenterIncidentalDeposit extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'incidental_deposit',
      'tab-pane': true
    })    
    return ( 
      <div className={tabClasses} id="incidental_deposit">
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" style={{marginBottom: 0}}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6">
                  <h3 className="panel-title">
                    {`${I18n.t('incidental_deposit')}*`} <span className="ss-help help" title={I18n.t('incidental_deposit_helper_text')}></span>
                  </h3>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="panel-body ht-row">
                { this.props.incidental_deposit 
                    ? <IncidentalDepositPresenter
                        incidental_deposit={this.props.incidental_deposit} 
                        nested={true} 
                        hideModalButtons={true}/>
                    : <div className="no-records">
                        <span className="none">{I18n.t('none')}</span>
                      </div>
                }     
              </div>           
            </div>
          </div>
        </div>
      </div>
    );
  };
};


